import React from 'react';
import './order-details.scss';
import { TouchableOpacity, Text } from '../../common';
import { SVGS } from '../../assets';

interface AddDiscountProps {
  isEdit?: boolean;
  onPress?: () => void;
  hidden?: boolean;
}

export const AddDiscount: React.FC<AddDiscountProps> = ({
  isEdit,
  onPress,
  hidden = false,
}) => {
  if (hidden) return null;

  return (
    <div className="order-details-promotions-discount-view" onClick={onPress}>
      <img src={SVGS.DiscountIconPurple} />
      <Text className="order-details-promotions-discount font-medium">
        {isEdit ? 'Edit Discount' : 'Apply Discount'}
      </Text>
    </div>
  );
};
